export default function Loading() {
    return (
        <div className="w-[100vw] rounded-lg border-[1px] border-slate-200 animate-pulse bg-gray-300 shadow-lg lg:w-[48rem] 2xl:w-[60rem] flex flex-col">
            <div className="w-full flex justify-center items-center gap-4 py-2 border-b border-gray-300 h-[40px]"></div>
            <div className="w-full p-4 h-[800px] "></div>
        </div>
    );
}
